/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import e from "../core/Error.js";
import { canProjectToWGS84ComparableLonLat as i } from "../geometry/projection.js";
import { isMars as t, isMoon as n } from "../geometry/support/spatialReferenceUtils.js";
import { getMissingTileInfoError as r, TilingScheme as l } from "../views/3d/terrain/TilingScheme.js";
function o() {
  return !0;
}
function s() {
  return 0;
}
function c(o, s) {
  if (null == o) return r();
  const c = o.lods.length - 1,
    a = o.spatialReference,
    m = i(a) || t(a) || n(a);
  if (a.isWebMercator) {
    if (!l.makeWebMercatorAuxiliarySphere(c).compatibleWith(o)) return new e("tilingscheme:incompatible-global-web-mercator", "The tiling scheme is not compatible with the ArcGIS Online Web Mercator tiling scheme");
  } else {
    if (!m) return new e("tilingscheme:global-unsupported-spatial-reference", "The tiling scheme spatial reference is not supported in global scenes");
    if (!l.makeGCSWithTileSize(o.spatialReference, o.size[0], c).compatibleWith(o)) return o.spatialReference.isWGS84 ? new e("tilingscheme:incompatible-global-wgs84", "The tiling scheme is not compatible with the ArcGIS Online WGS84 tiling scheme") : new e("tilingscheme:incompatible-global", "The tiling scheme is not compatible with the ArcGIS Online tiling scheme");
  }
  return null == s || o.spatialReference.equals(s) ? void 0 : new e("tilingscheme:spatial-reference-mismatch", "The tiling scheme does not match the spatial reference of the global scene");
}
const a = Object.freeze(Object.defineProperty({
  __proto__: null,
  checkIfTileInfoSupportedForViewSR: c,
  isInsideExtent: o,
  tiltToExtentEdge: s
}, Symbol.toStringTag, {
  value: "Module"
}));
export { s as a, c, o as i, a as t };